import { ROLES } from "../../auth/roles";

export type UserDto = {
  email: string;
  roles: ROLES[];
  schoolIds: string[];
};

export class User {
  constructor(
    public email: string,
    public roles: ROLES[],
    public schoolIds: string[],
  ) {}

  static fromUserDto({ email, roles, schoolIds }: UserDto): User {
    return new User(email, roles, schoolIds);
  }
}
